/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventPermissionRequestedFromJSON(json) {
    return StreemApiAnalyticEventPermissionRequestedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventPermissionRequestedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'permission': !exists(json, 'permission') ? undefined : json['permission'],
        'granted': !exists(json, 'granted') ? undefined : json['granted'],
        'inviteSid': !exists(json, 'invite_sid') ? undefined : json['invite_sid'],
        'promptShown': !exists(json, 'prompt_shown') ? undefined : json['prompt_shown'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'groupReservationSid': !exists(json, 'group_reservation_sid') ? undefined : json['group_reservation_sid'],
    };
}
export function StreemApiAnalyticEventPermissionRequestedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'permission': value.permission,
        'granted': value.granted,
        'invite_sid': value.inviteSid,
        'prompt_shown': value.promptShown,
        'reason': value.reason,
        'group_reservation_sid': value.groupReservationSid,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPermissionRequestedPermission;
(function (StreemApiAnalyticEventPermissionRequestedPermission) {
    StreemApiAnalyticEventPermissionRequestedPermission["CAMERA"] = "PERMISSION_CAMERA";
    StreemApiAnalyticEventPermissionRequestedPermission["INVALID"] = "PERMISSION_INVALID";
    StreemApiAnalyticEventPermissionRequestedPermission["LOCATION"] = "PERMISSION_LOCATION";
    StreemApiAnalyticEventPermissionRequestedPermission["MICROPHONE"] = "PERMISSION_MICROPHONE";
})(StreemApiAnalyticEventPermissionRequestedPermission || (StreemApiAnalyticEventPermissionRequestedPermission = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventPermissionRequestedReason;
(function (StreemApiAnalyticEventPermissionRequestedReason) {
    StreemApiAnalyticEventPermissionRequestedReason["CALL"] = "REASON_CALL";
    StreemApiAnalyticEventPermissionRequestedReason["GUIDEDSCAN"] = "REASON_GUIDED_SCAN";
    StreemApiAnalyticEventPermissionRequestedReason["INVALID"] = "REASON_INVALID";
})(StreemApiAnalyticEventPermissionRequestedReason || (StreemApiAnalyticEventPermissionRequestedReason = {}));
//# sourceMappingURL=StreemApiAnalyticEventPermissionRequested.js.map